import { Controller, Control } from "react-hook-form";
import Select from "@/components/Select";
import { FieldValues } from "../../career/_components/EmploymentFormModal";
import { TourCode } from "../queries";

interface A3TourCodeFieldProps {
  control: Control<FieldValues>;
  currentTourOptions: TourCode[];
  errors: Record<string, any>;
}

export function A3TourCodeField({ control, currentTourOptions, errors }: A3TourCodeFieldProps) {
  return (
    <Controller
      name="tourCode"
      control={control}
      rules={{ required: "Tour code is required for A-3 classification" }}
      render={({ field: { onChange, value } }) => (
        <Select
          label="Tour Code *"
          options={currentTourOptions.map((tour) => ({
            label: tour.name,
            value: tour.code
          }))}
          value={value}
          onSelect={onChange}
          error={!!errors.tourCode}
          errorText={errors.tourCode?.message}
          data-testid="tour-code-select"
        />
      )}
    />
  );
}
